import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { AppGalleryConfigService } from '../app-gallery/app-gallery-config.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class AppGalleryRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {
    private readonly appGalleryEnabled = !!this.appGalleryConfigService.config;

    constructor(
        private readonly appGalleryConfigService: AppGalleryConfigService,
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.appGalleryEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.appGalleryEnabled);
    }
}
